module.exports = __webpack_public_path__ + "img/opens.8282ebd3.png";